import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

export const deadlineBarStyles = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.xs,
  padding: "7px 0",
  lineHeight: 1,
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.heading.s,
});

export const eventName = style({
  margin: 0,
  fontSize: "inherit",
});

export const deadline = style({
  margin: 0,
  color: vars.colors.primary,
  fontSize: "inherit",
});
